import models from "modules/models";
import BaseRxApiService from "./baseRxApiService";

export default class PostRxApiService extends BaseRxApiService {
  constructor() {
    super(models.POST);
  }
}
